module.exports = __webpack_public_path__ + "72ec30a7316302fdcf40f3bcf2192ac4.png";